<script lang="ts" setup>
import AppButton from "~/components/ui/buttons/AppButton.vue";
import type {ICatalogFilterValue} from "~/shared/interfaces/catalog";

const props = withDefaults(defineProps<{
  btnTxt?: {
    open: string
    closed: string
  }
  itemsLength: number
  showOnStartCount: number
  gap: number
}>(), {
  btnTxt: () => {
    return {
      open: 'Свернуть',
      closed: 'Показать ещё'
    }
  }
})


const emits = defineEmits(['toggle-accordion'])

const isOpen = ref(false)
const contentGap = `${props.gap}px`
const accordionContent = ref<HTMLDivElement>()

let maxHeight = ref<number>()
const getStartHeight = () => (accordionContent.value?.children[0] as HTMLDivElement).offsetHeight * props.showOnStartCount + props.gap * (props.showOnStartCount - 1)

onMounted(() => {
  if (accordionContent.value?.children[0]) {
    maxHeight.value = getStartHeight()
  }
})

function handleAccordion() {
  if (accordionContent.value) {
    +accordionContent.value.style.maxHeight.replace('px', '') <= getStartHeight() ?
      maxHeight.value = accordionContent.value.scrollHeight :
      maxHeight.value = getStartHeight()
  }
  isOpen.value = !isOpen.value

  emits('toggle-accordion', isOpen.value)
}

</script>

<template>
  <div class="small-accordion">
    <div
      class="small-accordion__content"
      :style="{maxHeight: `${maxHeight}px`}"
      ref="accordionContent"
    >

      <slot name="content"/>
    </div>
    <AppButton
      v-if="itemsLength > showOnStartCount"
      class="small-accordion__btn"
      @click="handleAccordion"
      :text="isOpen ? btnTxt.open : btnTxt.closed"
      type="ghost"
      sub-type="primary"
      :font-weight="400"
      size="s"
    />
  </div>
</template>

<style lang="scss" scoped>
.small-accordion {
  &__content {
    display: flex;
    flex-direction: column;
    gap: v-bind(contentGap);
    overflow: hidden;
    transition: max-height .3s;
  }

  &__btn {
    margin-top: 8px;
  }
}
</style>
